import { useDispatch, useSelector } from "react-redux";
import {
  isAuthenticatedSelector,
  logoutUser,
  userSelector,
} from "./auth.slice";
import { KeycloakContext } from "./KeycloakContext";
import { useContext } from "react";

export const useKeycloak = () => {
  const context = useContext(KeycloakContext);
  if (!context) {
    throw new Error("useKeycloak must be used within a KeycloakProvider");
  }

  return context;
};

export const useAuth = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const user = useSelector(userSelector);

  return {
    user: user,
    isAuthenticated,
    logout(event) {
      event.preventDefault();
      dispatch(logoutUser());
    },
    check() {
      return !isAuthenticated;
    },
    isAdmin() {
      return isAuthenticated && user.admin;
    },
  };
};
